<div class="ss-modal-backdrop" (click)="onBackdropClick($event)">
  <div class="ss-modal-panel" (click)="$event.stopPropagation()">
    <div class="ss-modal-header">
      
      <div>
        <div class="ss-header-title">{{data.name | uppercase}} Substation</div>
        <div class="d-flex gap-3 align-items-center">
          <div class="d-flex gap-2 align-items-center">
            <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.75 8.25L4.5 0.75H11.4375L9.375 4.875H13.875L3 14.625L4.6103 8.25H0.75Z" stroke="#171717" stroke-opacity="0.4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="ss-header-label">Type</span> 
            <span class="ss-header-info">{{data.substationTemplateName}}</span>
          </div>
          <div class="d-flex gap-2 align-items-center">
            <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.75 8.25L4.5 0.75H11.4375L9.375 4.875H13.875L3 14.625L4.6103 8.25H0.75Z" stroke="#171717" stroke-opacity="0.4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="ss-header-label">Voltage</span>
             <span class="ss-header-info">{{data.baseVoltage?.voltageClass | hasValue}}</span>
          </div>
          <div class="d-flex gap-2 align-items-center">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.0625 7.5C11.0625 8.6391 10.1391 9.5625 9 9.5625C7.8609 9.5625 6.9375 8.6391 6.9375 7.5C6.9375 6.36092 7.8609 5.4375 9 5.4375C10.1391 5.4375 11.0625 6.36092 11.0625 7.5Z" stroke="#171717" stroke-opacity="0.4" stroke-width="1.5" stroke-linejoin="round"/>
              <path d="M14.4375 7.5C14.4375 10.916 11.3815 14.0125 9.85155 15.3486C9.35835 15.7794 8.64165 15.7794 8.14845 15.3486C6.61853 14.0125 3.5625 10.916 3.5625 7.5C3.5625 4.49696 5.99696 2.0625 9 2.0625C12.0031 2.0625 14.4375 4.49696 14.4375 7.5Z" stroke="#171717" stroke-opacity="0.4" stroke-width="1.5" stroke-linejoin="round"/>
            </svg>
            <span class="ss-header-label">Region</span>
            <span class="ss-header-info">{{data.subGeographicalRegion?.geographicalRegion.name | hasValue | uppercase}}</span>
          </div>
        </div>  
      </div>

      <div class="d-flex gap-2">
        <button *ngIf="permissionsService.isSchematicDiagramViewAllowed" class="ss-header-btn ss-header-info" (click)="openSchematic()">
          Schematic
        </button>
        <button *ngIf="permissionsService.isNetworkEntityClassesCreateEditAllowed"
          class="ss-header-btn ss-header-btn--edit ss-header-info"
          data-bs-toggle="modal" 
          data-bs-target="#editDetailsModal"
          (click)="selectSubstation()">
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.375 3.88644L12.9745 1.28697C13.6904 0.571009 14.8513 0.571009 15.5672 1.28697L17.0995 2.81924C17.8154 3.53521 17.8154 4.69601 17.0995 5.41197L14.5 8.01144M10.375 3.88644L1.28697 12.9745C0.943151 13.3183 0.75 13.7846 0.75 14.2708V17.6364H4.11561C4.60184 17.6364 5.06815 17.4433 5.41197 17.0995L14.5 8.01144M10.375 3.88644L14.5 8.01144" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button *ngIf="permissionsService.isNetworkEntityClassesDeleteAllowed" class="ss-header-btn ss-header-btn--delete ss-header-info"  data-bs-toggle="modal" data-bs-target="#deleteSsDetails">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.35547 5.96094L5.1253 16.9244C5.22645 18.3649 6.42451 19.4818 7.86855 19.4818H14.134C15.5781 19.4818 16.7761 18.3649 16.8773 16.9244L17.6471 5.96094" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.98047 5.27344H19.0221" stroke="#171717" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.8125 5.11504C8.00151 3.52337 9.35574 2.28906 10.9983 2.28906C12.6408 2.28906 13.9951 3.52337 14.1841 5.11504" stroke="#171717" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button type="button" class="ss-close-btn" style="border: none; background: transparent;" (click)="close()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#171717" fill-opacity="0.05"/>
            <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#171717" stroke-opacity="0.07"/>
            <path d="M8.375 8.375L15.625 15.625M15.625 8.375L8.375 15.625" stroke="#171717" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>

    </div>

    <div class="nec-tabs">
        <button
            *ngFor="let tab of tabs"
            [class.selected]="selectedTabId === tab.id"
            (click)="switchTab(tab)"
        >
            <span>{{ tab.name }}</span>
        </button>
    </div>

    <div class="ss-modal-body">

      <div *ngIf="selectedTabId === 1 && hasEquipment === false" class="d-flex flex-column align-items-center gap-4" style="margin-top: 30%;">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_18747_119571)">
          <rect width="30" height="30" rx="8" fill="#171717" fill-opacity="0.05"/>
          <path d="M7 9C7 8.46957 7.21071 7.96086 7.58579 7.58579C7.96086 7.21071 8.46957 7 9 7C9.53043 7 10.0391 7.21071 10.4142 7.58579C10.7893 7.96086 11 8.46957 11 9C11 9.53043 10.7893 10.0391 10.4142 10.4142C10.0391 10.7893 9.53043 11 9 11C8.46957 11 7.96086 10.7893 7.58579 10.4142C7.21071 10.0391 7 9.53043 7 9Z" fill="#171717" fill-opacity="0.7"/>
          <path opacity="0.6" d="M13 9C13 8.4 13.4 8 14 8H22C22.6 8 23 8.4 23 9C23 9.6 22.6 10 22 10H14C13.7348 10 13.4804 9.89464 13.2929 9.70711C13.1054 9.51957 13 9.26522 13 9Z" fill="#171717" fill-opacity="0.7"/>
          <path d="M7 15C7 14.4696 7.21071 13.9609 7.58579 13.5858C7.96086 13.2107 8.46957 13 9 13C9.53043 13 10.0391 13.2107 10.4142 13.5858C10.7893 13.9609 11 14.4696 11 15C11 15.5304 10.7893 16.0391 10.4142 16.4142C10.0391 16.7893 9.53043 17 9 17C8.46957 17 7.96086 16.7893 7.58579 16.4142C7.21071 16.0391 7 15.5304 7 15Z" fill="#171717" fill-opacity="0.7"/>
          <path opacity="0.6" d="M13 15C13 14.4 13.4 14 14 14H22C22.6 14 23 14.4 23 15C23 15.6 22.6 16 22 16H14C13.7348 16 13.4804 15.8946 13.2929 15.7071C13.1054 15.5196 13 15.2652 13 15Z" fill="#171717" fill-opacity="0.7"/>
          <path d="M7 21C7 20.4696 7.21071 19.9609 7.58579 19.5858C7.96086 19.2107 8.46957 19 9 19C9.53043 19 10.0391 19.2107 10.4142 19.5858C10.7893 19.9609 11 20.4696 11 21C11 21.5304 10.7893 22.0391 10.4142 22.4142C10.0391 22.7893 9.53043 23 9 23C8.46957 23 7.96086 22.7893 7.58579 22.4142C7.21071 22.0391 7 21.5304 7 21Z" fill="#171717" fill-opacity="0.7"/>
          <path opacity="0.6" d="M13 21C13 20.4 13.4 20 14 20H22C22.6 20 23 20.4 23 21C23 21.6 22.6 22 22 22H14C13.7348 22 13.4804 21.8946 13.2929 21.7071C13.1054 21.5196 13 21.2652 13 21Z" fill="#171717" fill-opacity="0.7"/>
          </g>
          <defs>
          <clipPath id="clip0_18747_119571">
          <rect width="30" height="30" rx="8" fill="white"/>
          </clipPath>
          </defs>
          </svg>
          <span class="ss-header-label">Select or create an equipment & connectivity to get started</span>
          <button class="btn save-modal-btn" (click)="hasEquipment = true">Add Equipment/Connectivity</button>
      </div>

      <div *ngIf="selectedTabId === 1 && hasEquipment === true" class="equipment-and-connectivity-wrapper">

        <div class="eac-sidebar">

          <div class="add-section">
            <span>{{eqCount}} Added</span>
            
          </div>

          <div class="d-flex flex-column gap-2 pe-4">

            <button *ngFor="let equipmentsConnectivity of equipmentsConnectivites" 
                    class="equipment-and-connectivity-list" 
                    [class.selected]="selectedEqConnId === equipmentsConnectivity.id"
                    (click)="switchEqConn(equipmentsConnectivity)"
            >
              <div>
                {{equipmentsConnectivity.name}}
              </div>

              <div>
                <!-- this is where delete should be after hover -->
              </div>

              <div>
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.30806 0C2.0301 0 2.61611 0.597333 2.61611 1.33333C2.61611 2.06933 2.0301 2.66667 1.30806 2.66667C0.58601 2.66667 0 2.06933 0 1.33333C0 0.597333 0.58601 0 1.30806 0Z" fill="#171717" fill-opacity="0.5"/>
                  <path d="M6.54243 0C7.26448 0 7.85049 0.597333 7.85049 1.33333C7.85049 2.06933 7.26448 2.66667 6.54243 2.66667C5.82038 2.66667 5.23438 2.06933 5.23438 1.33333C5.23438 0.597333 5.82038 0 6.54243 0Z" fill="#171717" fill-opacity="0.5"/>
                  <path d="M1.30806 5.33594C2.0301 5.33594 2.61611 5.93327 2.61611 6.66927C2.61611 7.40527 2.0301 8.0026 1.30806 8.0026C0.58601 8.0026 0 7.40527 0 6.66927C0 5.93327 0.58601 5.33594 1.30806 5.33594Z" fill="#171717" fill-opacity="0.5"/>
                  <path d="M6.54243 5.33594C7.26448 5.33594 7.85049 5.93327 7.85049 6.66927C7.85049 7.40527 7.26448 8.0026 6.54243 8.0026C5.82038 8.0026 5.23438 7.40527 5.23438 6.66927C5.23438 5.93327 5.82038 5.33594 6.54243 5.33594Z" fill="#171717" fill-opacity="0.5"/>
                  <path d="M1.30806 10.6641C2.0301 10.6641 2.61611 11.2614 2.61611 11.9974C2.61611 12.7334 2.0301 13.3307 1.30806 13.3307C0.58601 13.3307 0 12.7334 0 11.9974C0 11.2614 0.58601 10.6641 1.30806 10.6641Z" fill="#171717" fill-opacity="0.5"/>
                  <path d="M6.54243 10.6641C7.26448 10.6641 7.85049 11.2614 7.85049 11.9974C7.85049 12.7334 7.26448 13.3307 6.54243 13.3307C5.82038 13.3307 5.23438 12.7334 5.23438 11.9974C5.23438 11.2614 5.82038 10.6641 6.54243 10.6641Z" fill="#171717" fill-opacity="0.5"/>
                </svg>
              </div>
            </button>

          </div>

          <div style="flex: 1;"></div>
 

        </div>

        <div class="eac-content">

          <lib-nec-substation-details-power-transformer 
            *ngIf="selectedEqConnId === 1" 
            [substationId]="data.substationId" 
            [substationTemplateInstanceId]="data.id" 
            [substationVoltage]="data.baseVoltage?.voltageClass"
            [ratingOptions]="ratingOptions"
            (openSchematic)="openSchematic()"
          >
          </lib-nec-substation-details-power-transformer>

          <lib-nec-substation-details-ac-line 
            *ngIf="selectedEqConnId === 2" 
            [substationId]="data.substationId"
            (refreshOverview)="getAcLineCountForSubstation()"
          >
          </lib-nec-substation-details-ac-line>
          <lib-nec-substation-details-equipment
            *ngIf="selectedEqConnId === 3 || selectedEqConnId === 4 || selectedEqConnId === 5 || selectedEqConnId === 6
             || selectedEqConnId === 7 || selectedEqConnId === 8 || selectedEqConnId === 9 || selectedEqConnId === 10"
            [substationId]="data.id"
            [equipmentType]="equipmentsConnectivites[selectedEqConnId - 1].value"
            [equipmentName]="equipmentsConnectivites[selectedEqConnId - 1].name"
            [selectedEquipment]="selectedEquipment"
            (openSchematic)="openSchematic()"
            >
          </lib-nec-substation-details-equipment>
        </div>
      </div>
      <div *ngIf="selectedTabId === 2" class="asset-details-wrapper">
        <span class="section-header">Asset Details</span>

        <div class="asset-detail-row">
          <div class="header-label">Substation Name</div>
          <div class="header-info">{{data.name | hasValue | uppercase}}</div>
        </div>

        <div class="asset-detail-row">
          <div class="header-label">Number</div>
          <div class="header-info">{{data.number | hasValue}}</div>
        </div>

        <div class="asset-detail-row">
          <div class="header-label">Voltage</div>
          <div class="header-info">{{data.baseVoltage?.voltageClass | hasValue}}</div>
        </div>

        <div class="asset-detail-row">
          <div class="header-label">Geographical Region</div>
          <div class="header-info">{{data.subGeographicalRegion?.geographicalRegion.name | hasValue | uppercase}}</div>
        </div>

        <div class="asset-detail-row">
          <div class="header-label">Outgoing Feeders</div>
          <div class="header-info">{{acLineCounts.outgoingAcLinesCount }}</div>
        </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="deleteSsDetails"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content delete-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header delete-modal-header">
        <h5 class="modal-title" id="deleteBuTitle">
          {{ "CRUD_SETTINGS.ARE_YOU_SURE_DELETE" | translate }}
          {{ "COMMON.SUBSTATION" | translate }}?
        </h5>
      </div>
      <div class="modal-footer delete-modal-footer">
        <button 
            type="button" 
            class="btn btn-primary" 
            (click)="onRemove()"
            data-bs-dismiss="modal"
        >
          {{ "COMMON.DELETE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="editDetailsModal" tabindex="-1" aria-labelledby="exampleEditModalLabel" aria-hidden="true">
  <div style="max-width: 64rem;" class="modal-dialog modal-dialog-centered modal-lg">
    <form (ngSubmit)="save()"   
      style="border-radius: 20px;" class="modal-content rounded-5 shadow-lg border-0">
      <div class="modal-header border-0 pb-0">
        <h5 style="font-size: 2rem;" class="modal-title fw-semibold" id="exampleEditModalLabel">Update Substation</h5>
        <button type="button" style="border: none; background: transparent;" data-bs-dismiss="modal" aria-label="Zatvori">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#171717" fill-opacity="0.05"/>
            <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#171717" stroke-opacity="0.07"/>
            <path d="M8.375 8.375L15.625 15.625M15.625 8.375L8.375 15.625" stroke="#171717" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <p class="description-text">Fill out the fields carefully to update this instance, including all necessary information for identification.</p>
        <div 
          class="nec-substation-scroll new-instance-modal-body modal-body pt-3 m-0 w-100 align-items-center justify-content-between">
          <div class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Instance Category</p>
            </div>
            <div class="col-6">
                <lib-object-dropdown
                    [items]="substationTemplatesForSelect"
                    [displayField]="'className'" 
                    [initialValue]="substationTemplateValue"
                    (valueChange)="onSelectSubstationTemplate($event)"
                    [disabled]="true"
                    [isRequired]="true"
                    #dropdownInstance
                ></lib-object-dropdown>
            </div>
          </div>
          <div class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Asset Name</p>
            </div>
            <div class="col-6 mb-3">
              <input 
                class="new-instance-input w-100" 
                type="text" 
                name="code"
                placeholder=" "
                [(ngModel)]="substationForSave.name"
              />
            </div>
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Asset Number</p>
            </div>
            <div class="col-6">
              <input 
                class="new-instance-input w-100" 
                type="text" 
                name="number"
                placeholder=" "
                [(ngModel)]="substationForSave.number"
              />
            </div>
          </div>
          <div class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Base Voltage</p>
            </div>
            <div class="col-6">
              <lib-object-dropdown
                    [items]="baseVoltages"
                    [displayField]="'name'" 
                    [initialValue]="baseVoltageValue"
                    (valueChange)="onSelectBaseVoltage($event)"
                    [disabled]="false"
                    [isRequired]="true"
                    #dropdownVoltage
              ></lib-object-dropdown>
            </div>
          </div>
          <div class="section w-100 row pb-3">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Parent Substation Connection</p>
            </div>
            <div class="connectivity col-6 mb-4 pb-2">
              CONNECTIVITY
            </div>
            <div style="display: flex; flex-wrap: wrap; padding: 0;">
              <div *ngIf="showParentSubstationDropdowns" class="col-6"></div>

              <div *ngIf="showParentSubstationDropdowns" class="col-6 mb-3" style="padding: 0 7.5px;">
                <lib-object-dropdown
                  [items]="parentSubstations"
                  [displayField]="'name'" 
                  (valueChange)="onSelectParentSubstation($event)"
                  [placeholder]="'Select Substation'"
                  [isRequired]="true"
                  [isSearchEnabled]="true"
                  [maxDisplayItemSize]="10"
                  (searchTextChange)="onSearchTextChange($event)"
                ></lib-object-dropdown>
              </div>

              <div *ngIf="showParentSubstationDropdowns" class="col-6"></div>

              <div *ngIf="showParentSubstationDropdowns" class="col-6 mb-3" style="padding: 0 7.5px;">
                <lib-object-dropdown
                  [items]="outgoingAcLineSegments"
                  [displayField]="'name'" 
                  (valueChange)="onSelectAcLineOutoging($event)"
                  [disabled]="updatedParentSubstationId === null"
                  [placeholder]="'Select Ac Line Segment'"
                  [isRequired]="true"
                ></lib-object-dropdown>
              </div>
            </div>
            <div *ngIf="!(substationForSave.parentSubstations && substationForSave.parentSubstations.length > 0)" class="col-6"></div>
            <div *ngIf="!(substationForSave.parentSubstations && substationForSave.parentSubstations.length > 0)" class="outgoing-div col-6 mb-4 pb-4">
                <input
                  class="outgoing-input w-100"
                  type="text"
                  name="outgoingAcLines"
                  placeholder="                No outgoing added yet"
                  disabled
                />
            </div>
            <span *ngFor="let acLineOutoging of addedAcLinesOutgoing" class="d-flex" style="padding-right: 1.4rem;">
              <div class="col-6"></div>
              <div class="col-6 d-flex justify-content-between align-items-center ac-line-label">
                {{acLineOutoging.acLineName}} 
                <button *ngIf="!acLineOutoging.isExisting" type="button" class="ac-line-delete-btn" (click)="removeFromLists(acLineOutoging.acLineId);  $event.stopPropagation()">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.16406 4.33594L3.76748 12.9293C3.81652 13.6277 4.3974 14.1693 5.09753 14.1693H10.8973C11.5974 14.1693 12.1783 13.6277 12.2273 12.9293L12.8307 4.33594" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2.16406 3.83594H13.8307" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.67969 3.71932C5.81715 2.56174 6.80202 1.66406 7.99662 1.66406C9.19122 1.66406 10.1761 2.56174 10.3136 3.71932" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </span>
            <div class="col-6"></div>
            <div class="col-6">
              <button
                type="button"
                class="add-substation-bttn"
                (click)="addParentSubstation()"
              >
              Add Substation
              </button>
            </div>
          </div>
          <div class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Geographical Boundary</p>
            </div>
            <div class="col-6 mb-3">
                <lib-object-dropdown
                    [items]="geoRegions"
                    [displayField]="'name'" 
                    [initialValue]="geographicalRegionValue"
                    (valueChange)="onSelectGeographicalRegion($event)"
                    [disabled]="false"
                    [isRequired]="true"
                    [placeholder]="'Select Region'"
                    #dropdownRegion
                ></lib-object-dropdown>
            </div>
            <div class="col-6"></div>
            <div class="col-6">
                <lib-object-dropdown
                    [items]="subGeoRegions"
                    [displayField]="'name'" 
                    [initialValue]="subGeographicalRegionValue"
                    (valueChange)="onSelectSubGeographicalRegion($event)"
                    [disabled]="updatedRegionId === null"
                    [isRequired]="true"
                    [placeholder]="'Select District'"
                    #dropdownDistrict
                ></lib-object-dropdown>
            </div>
          </div>
          <div class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Supplied Region</p>
            </div>
            <div class="col-6 mb-3">
              <input 
                class="supplied-region-input w-100" 
                type="text" 
                name="suppliedRegion"
                [(ngModel)]="suppliedRegionName"
                placeholder=" " 
                disabled 
              />
            </div>
            <div class="col-6"></div>
            <div class="col-6">
              <input 
                class="supplied-region-input w-100" 
                type="text" 
                name="suppliedDistrict"
                [(ngModel)]="suppliedDistrictName"
                placeholder=" " 
                disabled 
              />
            </div>
          </div>
        </div>         
      <div class="modal-footer border-0">
        <button type="button" class="btn cancel-modal-btn" data-bs-dismiss="modal" #closeEditModal>Cancel</button>
        <button type="submit" class="btn save-modal-btn">Save</button>
      </div>
    </form>
  </div>
</div>

<lib-nec-substation-details-schematic
  *ngIf="isSchematicOpen"
  (closeSchematic)="closeSchematic()"
  [substationId]="data.substationId"
  [substationName]="data.name"
></lib-nec-substation-details-schematic>